// import the interface
import { UserActionType,All } from '../actions/user.action';

//create a dummy initial state
export interface State {
  // is a user authenticated?
  isAuthenticated: boolean;
  // if authenticated, there should be a user object
  user?: any;
  // error message
  errorMessage: string | null;
}

export const initialState: State = {
  isAuthenticated: false,
  errorMessage: null
};

export function userReducer(
  state = initialState,
  action: All
) {
  switch (action.type) {
    case UserActionType.GET_INFO:
      return state;
    case UserActionType.INFO_SUCCESS:
        return {...state, user:action.payload?.data};
    default:
      return state;
  }
}

// export function reducer(state = initialState, action: All): State {
//   switch (action.type) {
//     case UserActionType.GET_INFO: {
//       return {
//         ...state,
//         isAuthenticated: true,
//         user: {
//           token: action.payload.token,
//           email: action.payload.email
//         },
//         errorMessage: null
//       };
//     }
//     default: {
//       return state;
//     }
//   }
// }
